import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = ["Not a gym", "No random workouts", "Exercise with intent"];
  const looped = [...items, ...items, ...items];
  return (
    <section className="border-y border-[#1E1E1E]/10 py-10 lg:py-14 bg-[#F5F4EF]" data-testid="marquee-section">
      <div className="marquee-mask">
        <Marquee gradient={false} speed={35} pauseOnHover>
          <div className="flex items-center gap-16 pr-16">
            {looped.map((t, i) => (
              <div key={i} className="flex items-center gap-16">
                <span className="italic font-normal tracking-[0.005em] text-4xl md:text-6xl lg:text-7xl text-[#1E1E1E] whitespace-nowrap">
                  {t}
                </span>
                <span className="w-2 h-2 rounded-full bg-[#A67C00]" aria-hidden />
              </div>
            ))}
          </div>
        </Marquee>
      </div>
    </section>
  );
}
